import * as React from "react"
import { Link } from "gatsby"

import Home from "../components/home"
import Seo from "../components/seo"

const MakewebsitePage = () => (
  <Home>
  <div className="masthead-followup row m-0 lead text-center">
	  <div className="col-12 col-md-12">
      <Seo title="MAKE NEW MODERN WEBSITE" />
    <h2><strong><a href="/createwebsite">MAKE A WEBSITE</a></strong></h2><hr/>
   <p>
Select your favorite technology to develope build and create you modern website
</p>
</div>
<div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website cheap price with blogspot blogger" className="p-3 p-md-5 shadow rounded btn btn-outline-warning" to="/blogspot">
<img width="512" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/makewebsitecheapprice.png"/>
<h3>Blogger</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website flatfile grav modern website" className="p-3 p-md-5 shadow rounded btn btn-outline-danger" to="/grav">
<img width="512" alt="grav cms software website" src="https://mesinkasironline.web.app/img/createwebsitewithgrav.png"/>
<h3>Grav</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with wordpress" className="p-3 p-md-5 shadow rounded btn btn-outline-info" to="/wordpress">
<img width="512" alt="create website using wordpress popular cms" src="https://mesinkasironline.web.app/img/makewebsitewordpress.png"/>
<h3>Wordpress</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with modx revolutions" className="p-3 p-md-5 shadow rounded btn btn-outline-success" to="/modx">
<img width="512" alt=" cms software website MODX" src="https://mesinkasironline.web.app/img/createwebsitemodx.png"/>
<h3>ModX</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with automad flatfile" className="p-3 p-md-5 shadow rounded btn btn-outline-dark" to="/automad">
<img height="215" width="412" className="rounded-pill" alt=" cms software website Automad" src="https://mesinkasironline.web.app/img/createwebsiteautomadflatfilecms.png"/>
<h3>AutoMad</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with drupal" className="p-3 p-md-5 shadow rounded btn btn-outline-primary" to="/drupal">
<img width="512" alt="Drupal cms software website" src="https://mesinkasironline.web.app/img/createwebsitepowerfullwithdrupal.png"/>
<h3>Drupal</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with subrion" className="p-3 p-md-5 shadow rounded btn btn-outline-warning" to="/subrion">
<img width="512" alt="Subrion cms application website" src="https://mesinkasironline.web.app/img/createwebsitepowerfullwithsurbion.png"/>
<h3>Subrion</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with pagekit" className="p-3 p-md-5 shadow rounded btn btn-outline-info" to="/pagekit">
<img height="215" width="512" alt="Pagekit cms software website" src="https://mesinkasironline.web.app/img/pagekit-icon.png"/>
<h3>Page Kit</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website using photoshop" className="p-3 p-md-5 shadow rounded btn btn-outline-primary" to="/photoshop">
<img width="512" alt="Photoshop" src="https://mesinkasironline.web.app/img/webphotoshop.png"/>
<h3>Photoshop</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with textpatern" className="p-3 p-md-5 shadow rounded btn btn-outline-dark" to="/textpatern">
<img width="512" alt="textpatern website" src="https://mesinkasironline.web.app/img/createwebsitemakereasy.png"/>
<h3>Text Patern</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with monstra" className="p-3 p-md-5 shadow rounded btn btn-outline-danger" to="/monstra">
<img width="512" alt="create website using monstra" src="https://mesinkasironline.web.app/img/createsimplewebsite.png"/>
<h3>Monstra</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with bludit flatfile cms" className="p-3 p-md-5 shadow rounded btn btn-outline-dark" to="/bludit">
<img width="512" height="250" className="img-fluid" alt="create website bludit" src="https://mesinkasironline.web.app/img/websitecheapprice.png"/>
<h3>Bludit</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with Phyton Nikola" className="p-3 p-md-5 shadow rounded btn btn-outline-warning" to="/nikola">
<img className="img-fluid" width="512" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsitewithphytonnikola.png"/>
<h3>Phyton Nikola</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with bootstrap" class="p-3 p-md-5 shadow rounded btn btn-outline-primary" to="/bootstrap">
<img className="img-fluid" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsitewithbootstrap.png"/>
<h3>Bootstrap</h3>
</Link>
    </div>
   <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with jekyll ruby on rails" className="p-3 p-md-5 shadow rounded btn btn-outline-danger" to="/jekyll">
<img width="512" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsitestaticwithjekyll.png"/>
<h3>Jekyll Ruby</h3>
</Link>
    </div>
        <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with Code Iginter" className="p-3 p-md-5 shadow rounded btn btn-outline-warning" to="/codeiginter">
<img width="512" alt="code igniter" src="https://mesinkasironline.web.app/img/createwebsiteusingcodeiginiter.png"/>
<h3>Code Iginter</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with Laravel" className="p-3 p-md-5 shadow rounded btn btn-outline-danger" to="/laravel">
<img width="512" alt="laravel php artisan" src="https://mesinkasironline.web.app/img/createwebsitelaravel.png"/>
<h3>Laravel</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with gatsby js" className="p-3 p-md-5 shadow rounded btn btn-outline-primary" to="/gatsby">
<img width="512" alt="create website using modern technology javascript" src="icons/icon-384x384.png"/>
<h3>Gatsby</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with angular" className="p-3 p-md-5 shadow rounded btn btn-outline-danger" to="/angular">
<img className="img-fluid" width="512" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsiteusingangular.png"/>
<h3>Angular</h3>
</Link>
    </div>
    <div className="col-12 col-md-3 p-3 p-md-3 text-center">
<Link title="create website with react" className="p-3 p-md-5 shadow rounded btn btn-outline-info" to="/react">
<img className="img-fluid" alt="create website using modern technology javascript" src="https://mesinkasironline.web.app/img/createwebsiteusingreact.png"/>
<h3>React</h3>
</Link>
    </div>

    </div>
  </Home>
)

export default MakewebsitePage